import React, { useState, useEffect } from "react";
import { useWindowSize } from "react-use";
import styled from "styled-components";
import instance from "../../util/axios";
import { getQueryString } from "../../util/getQueryString";
import Designer, { ReportDef } from "./Designer";

export interface transferItem {
  key?: string;
  uuid: string;
  tableName: string;
  name: string;
}

export const ReportNameWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    flex: 0 0 70px;
  }
`;

const id: string = getQueryString("id") || "";
let chartHeight: any = getQueryString("chartHeight");
if (chartHeight) {
  chartHeight = parseInt(chartHeight);
}
console.log(chartHeight);
export default function StatisticalCard() {
  const [selectedTables, setSelectedTables] = useState<transferItem[]>([]);
  const [fieldJoins, setFieldJoins] = useState<{ [key: string]: string }[]>([]);
  const [reportData, setReportData] = useState<ReportDef>();
  const [reportName, setReportName] = useState("未命名");

  useEffect(() => {
    if (id) {
      instance
        .get(`/oa/q/qti?tableName=chart_report_def&id=${id}`)
        .then((resp) => {
          if (resp.data.Status === "1") {

            const data = resp.data.Data;
            const newData = {
              uuid: data.uuid,
              name: data.name,
              statistiChartType: data.statistiChartType || "bar",
              topFields: eval(data.topFields),
              leftFields: eval(data.leftFields),
              aggregateDefs: eval(data.aggregateDefs),
              objectDefs: eval(data.objectDefs),
              preDefinedFiltersForAggregate: eval(
                data.preDefinedFiltersForAggregate
              ),
              preDefinedFiltersForReport: eval(data.preDefinedFiltersForReport),
              joins: eval(data.joins),
              filters: eval(data.filters),
              reportFromRow: data.reportFromRow,
              chartSort: data.chartSort,
              sheetContent: eval(data.sheetContent),
            };
            setReportData(newData);
            setReportName(newData.name);
            setSelectedTables(newData.objectDefs);
            setFieldJoins(newData.joins);
            // setChartHeight(data.statistiChartType === "map" ? 500 : 330);
          }
        });
    } else {
      setReportData({
        uuid: "",
        name: "",
        topFields: [],
        leftFields: [],
        aggregateDefs: [],
        objectDefs: [],
        preDefinedFiltersForReport: [],
        preDefinedFiltersForAggregate: [],
        joins: [],
        filters: [],
        reportFromRow: 1,
        sheetContent: [],
        statistiChartType: "bar",
      });
    }
  }, []);

  return (
    <>
      {selectedTables.length > 0 && (
        <div style={{ background: "#ffffff" }}>
          <Designer
            selectedObject={selectedTables}
            fieldJoins={fieldJoins}
            defaultReportData={reportData}
            name={reportName}
            showReport={undefined}
            showStatisticalChart={"1"}
            chartHeight={chartHeight}
            isApp={"true"}
            id={id}
          />
        </div>
      )}
    </>
  );
}
